var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { connectionStore, userStaleDataStore } from "../../Stores";
import { getUserId } from "../GetUserId";
export function tokenRenewHandler(connectionName, shouldCheckUser = false) {
    return function (prevToken, nextToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const conn = connectionStore.get(connectionName);
            if (conn &&
                nextToken !== prevToken) {
                conn.updateToken(nextToken);
                if (shouldCheckUser && getUserId(nextToken) !== getUserId(prevToken)) {
                    userStaleDataStore.getKeys().forEach(callback => {
                        typeof callback === "function" && callback();
                    });
                }
                yield conn.deactivate();
            }
        });
    };
}
//# sourceMappingURL=TokenRenewHandler.js.map